import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import {
  IStudentSubscriptionRateVersion,
  IStudentSubscriptionRateVersionDeleteVerificationData,
} from '.';

export type TAdminCreateStudentSubscriptionRateVersion = {
  name: IStudentSubscriptionRateVersion['name'];
};

export type TAdminGetStudentSubscriptionRateVersions = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateStudentSubscriptionRateVersion = {
  id: string;
  name: IStudentSubscriptionRateVersion['name'];
};

const apiDataProvider = new APIDataProvider();

const adminGetStudentSubscriptionRateVersionsModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetStudentSubscriptionRateVersions) => {
  let path = `${AdminApiPaths.adminStudentSubscriptionRateVersions}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IStudentSubscriptionRateVersion>>
  >(path);

  return response.data;
};

export const adminCreateStudentSubscriptionRateVersion = createAsyncThunk(
  '/admin/student-subscription-rate-versions/create',
  async (data: TAdminCreateStudentSubscriptionRateVersion) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRateVersions}`;

    const response = await apiDataProvider.post<
      TApiResponse<IStudentSubscriptionRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateStudentSubscriptionRateVersion = createAsyncThunk(
  '/admin/student-subscription-rate-versions/update',
  async (data: TAdminUpdateStudentSubscriptionRateVersion) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRateVersions}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IStudentSubscriptionRateVersion>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteStudentSubscriptionRateVersion = createAsyncThunk(
  '/admin/student-subscription-rate-versions/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRateVersions}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IStudentSubscriptionRateVersion>
    >(path);

    return response.data;
  }
);

export const adminVerifyStudentSubscriptionRateVersionDelete = createAsyncThunk(
  '/admin/student-subscription-rate-versions/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminStudentSubscriptionRateVersions}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IStudentSubscriptionRateVersionDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetStudentSubscriptionRateVersions = createAsyncThunk(
  '/admin/student-subscription-rate-versions/list',
  adminGetStudentSubscriptionRateVersionsModule
);

export const adminGetStudentSubscriptionRateVersionsForDropDown = createAsyncThunk(
  '/admin/student-subscription-rate-versions/dropdown-list',
  adminGetStudentSubscriptionRateVersionsModule
);
